<template>
    <div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ព័ត៌មានលម្អិត</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
                        <div class="md-layout">
                            <div class="md-layout-item md-medium-size-100 md-small-size-100 md-size-100">
                                <h4 class="order-title" style="display: flex;align-items: center;">
                                   <b>ព័ត៌មានអំពីភាពយន្ត</b>
                                    <router-link :to="'/films/edit/' + film.hash">
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
                                        </md-button>
                                    </router-link>

                                    <md-button class="md-just-icon md-simple md-primary" @click="enableFilm(film.hash)" v-if="film.status == 0">
                                        <md-icon>done</md-icon>
                                        <md-tooltip md-direction="top">ដាក់ដំណើរការ</md-tooltip>
                                    </md-button>
                                    <md-button class="md-just-icon md-simple md-primary" @click="disableFilm(film.hash)" v-if="film.status == 1">
                                        <md-icon>visibility_off</md-icon>
                                        <md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
                                    </md-button>
                                    <md-button class="md-just-icon md-simple md-primary" @click="applySlideshow(film.hash)">
                                        <md-icon>compare</md-icon>
                                        <md-tooltip md-direction="top">ដាក់ចូលផ្ទាំងស្លាយ</md-tooltip>
                                    </md-button>
                                </h4>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-40">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">លេខកូដរឿង</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell><b>{{film.hash || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">ចំណងជើង</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell><b>{{film.title || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>បណ្តុំរឿង</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{film.film_category_name.replace("||", ", ") || "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ឆ្នាំចេញផ្សាយ</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{film.year|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>កម្រឹតរូបភាព</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.getQuality(film.quality)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ភាសា</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.getLanguage(film.language)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ដៃគូសហការ</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{film.partner_name}} {{film.dividend}}%</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell colspan="3">{{film.description}}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-40">
                                <md-table>
                                    <md-table-row>
                                        <md-table-cell style="width: 30%;">ប្រភេទរឿង</md-table-cell>
                                        <md-table-cell style="width: 5px">:</md-table-cell>
                                        <md-table-cell><b>{{config.getType(film.type)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ប្រភេទជាវ</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.getSubscription(film.subscription)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ការបង្ហាញរឿង</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.getPlatform(film.visibility)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>តម្លៃសម្រាប់ជួល</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.moneylify(film.rental_price)|| "N/A"}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ស្ថានភាពបម្លែងទាំងអស់</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <template v-if="film.type == 'movie'">
                                                <span class="green" v-if="film.server_processing_status == 1">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                                <span class="red" v-if="film.server_processing_status == 0">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                                <span class="yellow" v-if="film.server_processing_status == 2">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                            </template>
                                            <template v-else>
                                                <span class="green">សូមត្រួតពិនិត្យខាងក្រោម</span>
                                            </template>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ស្ថានភាព</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell>
                                            <span class="green" v-if="film.status == 1">{{config.getStatus(film.status)}}</span>
                                            <span class="red" v-if="film.status == 0">{{config.getStatus(film.status)}}</span>
                                        </md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>អ្នកមើលសរុប</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{film.total_view + film.total_all_view}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell>ថ្ងៃបង្កើត</md-table-cell>
                                        <md-table-cell>:</md-table-cell>
                                        <md-table-cell><b>{{config.datelify(film.created_date)[1] || 0}}</b></md-table-cell>
                                    </md-table-row>
                                    <md-table-row>
                                        <md-table-cell colspan="3">{{film.keyword}}</md-table-cell>
                                    </md-table-row>
                                </md-table>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-20 text-center">
                                <img :src="config.cdn + 'images/' + film.poster_url" style="max-width: 200px;">
                                <img :src="config.cdn + 'images/' + film.cover_url" style="max-width: 200px; margin-top: 20px;">
                            </div>
                            <div class="md-layout-item md-small-size-100 md-medium-size-100 md-size-100">
                                <h4 class>វីដេអូ</h4>
                            </div>
                            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="min-width: 1200px; overflow-x: scroll;" v-if="film.type == 'movie'">
                                <div class="md-layout">
                                    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                                        <div class="episode-container">
                                            <div class="episode-video">
                                                <img :src="config.cdn + 'images/' + 'video-cover.png'" style="width: 128px; height: 72px; margin-right: 10px">
                                            </div>
                                            <div style="flex-grow: 1;padding: 12px; display: flex; align-items: center;">{{film.title}}</div>
                                            <div style="padding: 12px; display: flex; align-items: center;">{{film.duration}} នាទី</div>
                                            <div style="padding: 12px; display: flex; align-items: center;">ពង្រីក {{film.server_video_padding_percentage}}%</div>
                                            <div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
                                                <span class="green" v-if="film.server_processing_status == 1">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                                <span class="red" v-if="film.server_processing_status == 0">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                                <span class="yellow" v-if="film.server_processing_status == 2">{{config.getProcessStatus(film.server_processing_status)}}</span>
                                            </div>
                                            <div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
                                                <span class="green" v-if="film.status == 1">{{config.getStatus(film.status)}}</span>
                                                <span class="red" v-if="film.status == 0">{{config.getStatus(film.status)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="min-width: 1200px; overflow-x: scroll;" v-if="film.type == 'series'">
                                <div class="md-layout" v-for="(season, s) in series">
                                    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                                        <div style="display: flex; flex-direction: row; align-items: center;">
                                            <h4>Season {{s+1}}</h4>
                                        </div>
                                    </div>
                                    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" v-for="(episode, e) in series[s]">
                                        <div class="episode-container">
                                            <div class="episode-order"><b>{{e+1}}</b></div>
                                            <div class="episode-video">
                                                <img :src="config.cdn + 'images/' + series[s][e].poster_url" style="width: 128px; height: 72px; margin-right: 10px">
                                            </div>
                                            <div style="flex-grow: 1;padding: 12px; display: flex; align-items: center;">{{series[s][e].title}}</div>
                                            <div style="padding: 12px;display: flex; align-items: center;">{{series[s][e].duration}} នាទី</div>
                                            <div style="padding: 12px; display: flex; align-items: center;">ពង្រីក {{series[s][e].server_video_padding_percentage}}%</div>
                                            <div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
                                                <span class="green" v-if="series[s][e].server_processing_status == 1">{{config.getProcessStatus(series[s][e].server_processing_status)}}</span>
                                                <span class="red" v-if="series[s][e].server_processing_status == 0">{{config.getProcessStatus(series[s][e].server_processing_status)}}</span>
                                                <span class="yellow" v-if="series[s][e].server_processing_status == 2">{{config.getProcessStatus(series[s][e].server_processing_status)}}</span>
                                            </div>
                                            <div style="display: flex; align-items: center; justify-content: center; padding: 12px; width: 180px">
                                                <span class="green" v-if="series[s][e].status == 1">{{config.getStatus(series[s][e].status)}}</span>
                                                <span class="red" v-if="series[s][e].status == 0">{{config.getStatus(series[s][e].status)}}</span>
                                            </div>
                                            <div style="padding: 12px; justify-content: center; align-items: center; display: flex;">
                                                <md-button class="md-just-icon md-success" style="margin-left: 5px" @click="enableEpisode(series[s][e].hash)" v-if="series[s][e].status == 0"><md-icon>done</md-icon><md-tooltip md-direction="top">ដាក់ដំណើរការ</md-tooltip></md-button>
                                                <md-button class="md-just-icon md-danger" style="margin-left: 5px" @click="disableEpisode(series[s][e].hash)" v-if="series[s][e].status == 1"><md-icon>visibility_off</md-icon><md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip></md-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
					</div>
                    <md-dialog-confirm :md-active.sync="enableFilmActive" md-title="តើអ្នកពិតជាចង់ដាក់ដំណើរការ ?" md-confirm-text="យល់ព្រម" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="enableFilm()" />
                    <md-dialog-confirm :md-active.sync="disableFilmActive" md-title="តើអ្នកពិតជាចង់ផ្អាកដំណើរការ ?" md-confirm-text="យល់ព្រម" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="disableFilm()" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.getFilm();
		},
		data() {
			return {
				loaded: false,
				film: null,
                series: [],
				enableFilmActive: false,
                disableFilmActive: false,
                enableEpisodeActive: false,
                disableEpisodeActive: false
			}
		},
		methods: {
			getFilm() {
				this.$http.get(this.config.api + "/user/film/get/" + this.$route.params.hash).then(data => {
					this.film = data.body.data.film;
                    this.series = data.body.data.series;
					this.loaded = true;
				})
			},
            enableFilm() {
                if(!this.enableFilmActive) { this.enableFilmActive = true; return; }
				this.$http.post(this.config.api + "/user/film/enable", {
                    hash: this.$route.params.hash
                }).then(data => { if (data.body.status == 'success') { this.getFilm(); } })
            },
            disableFilm() {
                if(!this.disableFilmActive) { this.disableFilmActive = true; return; }
				this.$http.post(this.config.api + "/user/film/disable", {
                    hash: this.$route.params.hash
                }).then(data => { if (data.body.status == 'success') { this.getFilm(); } })
            },
            enableEpisode(hash) {
				this.$http.post(this.config.api + "/user/film/enable_episode", {
                    hash: hash
                }).then(data => { if (data.body.status == 'success') { this.getFilm(); } })
            },
            disableEpisode(hash) {
				this.$http.post(this.config.api + "/user/film/disable_episode", {
                    hash: hash
                }).then(data => { if (data.body.status == 'success') { this.getFilm(); } })
            },
            applySlideshow(hash) {
                this.$http.post(this.config.api + "/user/film/apply_slideshow", {
                    hash: hash
                }).then(data => { if (data.body.status == 'success') { 
                    this.$notification.notify({
                        message: "ដាក់បញ្ចូលបានដោយជោគជ័យ។",
                        icon: 'done',
                        type: 'success'
                    })
                    this.getFilm(); 
                } })
            },
			onCancel() {
				this.disableFilmActive = false;
                this.enableFilmActive = false;
                this.enableEpisodeActive = false;
                this.disableEpisodeActive = false;
			}
		}
	}
</script>
<style scoped>
    .poster-upload {
		width: 70%;
		max-width: 300px;
	}
	.episode-container {
		border: 1px solid #F0F0F0; border-radius: 8px; width: 100%; display: flex; flex-direction: row;margin-bottom: 8px; background-color: #FFF;
	}
	.episode-order {
		padding: 12px; justify-content: center; align-items: center; display: flex;
	}
	.episode-video {
		display: flex; flex-direction: row; align-items: center; padding: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Films/Detail.vue